import type { PartnerContact, PartnerContactOutcome, PartnerLead } from '@bliks-io/contracts';
import { normalizedKey } from '@/lib/draft-rows/normalizedKey';

/**
 * The HubSpot lead behind each contact, found by email. HubSpot is where a
 * lead lives, so this holds however the lead got there: from the contact's
 * own button, the "New lead" dialog, or before the contact list existed.
 */
export function matchContactsToLeads(
  contacts: PartnerContact[],
  leads: PartnerLead[]
): Map<string, PartnerLead> {
  const leadsByEmail = new Map<string, PartnerLead>();
  for (const lead of leads) {
    const email = normalizedKey(lead.email ?? undefined);
    if (email && !leadsByEmail.has(email)) leadsByEmail.set(email, lead);
  }

  const matches = new Map<string, PartnerLead>();
  for (const contact of contacts) {
    const lead = leadsByEmail.get(normalizedKey(contact.email));
    if (lead) matches.set(contact._id, lead);
  }
  return matches;
}

/**
 * A contact found in HubSpot is a lead, whatever was stored on it; the stored
 * outcome covers contacts without email and the delay until a new lead shows up
 * in HubSpot.
 */
export function effectiveOutcome(
  contact: PartnerContact,
  matchedLead: PartnerLead | undefined
): PartnerContactOutcome | undefined {
  return matchedLead ? 'lead' : contact.outcome;
}
